export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DeleteThirdPartyDialog.json?hash=3f22f0d8628205a0c85309db365c7c85";